export interface VideoItem {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  date: string;
  tags: string[];
}

export const videoCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'short', name: '短视频', icon: 'ri-smartphone-line' },
  { slug: 'music', name: '音乐', icon: 'ri-music-line' },
  { slug: 'lifestyle', name: '生活', icon: 'ri-heart-line' },
];

export const hotVideos: VideoItem[] = [
  {
    id: 'v1',
    title: '流浪地球3：星辰大海',
    description: '在浩瀚的宇宙中，人类文明的命运再次悬于一线。面对未知的星际威胁，一支勇敢的探险队踏上了拯救地球的壮丽征程。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20astronauts%20in%20space%2C%20distant%20galaxy%2C%20dramatic%20lighting%2C%20cinematic%20widescreen%20composition%2C%20warm%20orange%20and%20deep%20space%20contrast%2C%20movie%20poster%20quality%2C%20professional%20film%20photography&width=800&height=450&seq=douhua-v1&orientation=landscape',
    duration: '128分钟',
    views: 8932000,
    rating: 9.2,
    date: '2026-07-15',
    tags: ['科幻', '冒险', '国产大片'],
  },
  {
    id: 'v2',
    title: '山河令：江湖再起',
    description: '一段跨越江湖恩怨的传奇故事，两个命运交织的灵魂在乱世中寻找真相与救赎。',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20ancient%20warriors%20in%20traditional%20costumes%2C%20misty%20mountains%2C%20bamboo%20forest%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20professional%20film%20photography&width=800&height=450&seq=douhua-v2&orientation=landscape',
    duration: '45集',
    views: 12560000,
    rating: 9.5,
    date: '2026-06-20',
    tags: ['武侠', '古装', '热门剧集'],
  },
  {
    id: 'v3',
    title: '欢乐喜剧人2026',
    description: '全国顶尖喜剧人齐聚一堂，带来最爆笑的原创喜剧作品，让你笑到停不下来。',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20stage%20with%20colorful%20lights%2C%20performers%20on%20stage%2C%20audience%20laughing%2C%20bright%20warm%20stage%20lighting%2C%20entertainment%20show%20photography&width=800&height=450&seq=douhua-v3&orientation=landscape',
    duration: '90分钟',
    views: 6710000,
    rating: 8.8,
    date: '2026-08-01',
    tags: ['喜剧', '综艺', '搞笑'],
  },
  {
    id: 'v4',
    title: '舌尖上的中国·新篇章',
    description: '跟随镜头探寻中国各地最地道的美食，感受食物背后的人文故事与匠心传承。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20noodles%20in%20traditional%20kitchen%2C%20warm%20natural%20light%2C%20steam%20rising%2C%20rustic%20atmosphere%2C%20professional%20food%20photography&width=800&height=450&seq=douhua-v4&orientation=landscape',
    duration: '52分钟',
    views: 4520000,
    rating: 9.7,
    date: '2026-05-10',
    tags: ['美食', '纪录片', '人文'],
  },
  {
    id: 'v5',
    title: '斗罗大陆：魂师传说',
    description: '在武魂的世界里，少年唐三凭借坚韧不拔的意志，一步步成长为最强魂师。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20fantasy%20scene%20with%20young%20hero%20in%20magical%20landscape%2C%20glowing%20spirit%20energy%2C%20epic%20battle%20stance%2C%20vibrant%20colors%2C%20anime%20art%20style&width=800&height=450&seq=douhua-v5&orientation=landscape',
    duration: '25分钟/集',
    views: 21300000,
    rating: 9.3,
    date: '2026-07-28',
    tags: ['国漫', '热血', '玄幻'],
  },
  {
    id: 'v6',
    title: '城市漫步：成都慢生活',
    description: '走进成都的大街小巷，感受这座千年古城的悠闲节奏与独特烟火气息。',
    category: 'lifestyle',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chengdu%20city%20street%20scene%20with%20traditional%20tea%20house%2C%20bamboo%20chairs%2C%20people%20relaxing%2C%20warm%20afternoon%20sunlight%2C%20local%20Chinese%20culture%2C%20travel%20photography&width=800&height=450&seq=douhua-v6&orientation=landscape',
    duration: '18分钟',
    views: 2340000,
    rating: 8.6,
    date: '2026-07-05',
    tags: ['旅行', '生活', '成都'],
  },
  {
    id: 'v7',
    title: '华语音乐巅峰之夜',
    description: '汇聚华语乐坛最具实力的歌手，带来一场震撼心灵的音乐盛宴。',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20music%20concert%20stage%20with%20singer%20performing%2C%20dramatic%20stage%20lighting%2C%20large%20crowd%2C%20concert%20atmosphere%2C%20professional%20live%20music%20photography&width=800&height=450&seq=douhua-v7&orientation=landscape',
    duration: '120分钟',
    views: 5670000,
    rating: 9.0,
    date: '2026-06-15',
    tags: ['音乐', '演唱会', '华语'],
  },
  {
    id: 'v8',
    title: '爆笑短视频合集：年度精选',
    description: '精选年度最搞笑的短视频内容，涵盖了生活中的各种有趣瞬间和创意作品。',
    category: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20short%20video%20compilation%20thumbnail%20with%20pet%20dog%20wearing%20sunglasses%2C%20bright%20colorful%20background%2C%20playful%20vibe%2C%20social%20media%20style%2C%20entertainment%20content&width=800&height=450&seq=douhua-v8&orientation=landscape',
    duration: '15分钟',
    views: 18700000,
    rating: 8.9,
    date: '2026-08-02',
    tags: ['搞笑', '合集', '短视频'],
  },
];

export const allVideos: VideoItem[] = [
  ...hotVideos,
  {
    id: 'v9',
    title: '星际迷航：新纪元',
    description: '人类首次踏足银河系边缘，在陌生的星球上发现了一个惊天秘密。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Space%20exploration%20movie%20scene%20with%20spaceship%20approaching%20alien%20planet%2C%20nebula%20colors%2C%20cinematic%20widescreen%2C%20dramatic%20lighting%2C%20sci-fi%20film%20aesthetic&width=800&height=450&seq=douhua-v9&orientation=landscape',
    duration: '142分钟',
    views: 3450000,
    rating: 8.7,
    date: '2026-04-20',
    tags: ['科幻', '冒险', '好莱坞'],
  },
  {
    id: 'v10',
    title: '青春有你·毕业季',
    description: '记录大学校园里最真实动人的青春故事，每一帧都是珍贵的回忆。',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20drama%20scene%20with%20university%20students%20on%20campus%2C%20cherry%20blossoms%2C%20warm%20sunlight%2C%20nostalgic%20atmosphere%2C%20youth%20film%20photography&width=800&height=450&seq=douhua-v10&orientation=landscape',
    duration: '24集',
    views: 7890000,
    rating: 9.0,
    date: '2026-05-25',
    tags: ['青春', '校园', '治愈'],
  },
  {
    id: 'v11',
    title: '国家宝藏·第六季',
    description: '走进中国各大博物馆，解密国宝文物背后的传奇历史故事。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20museum%20interior%20with%20ancient%20bronze%20artifacts%20displayed%2C%20dramatic%20museum%20lighting%2C%20historical%20atmosphere%2C%20cultural%20heritage%20photography&width=800&height=450&seq=douhua-v11&orientation=landscape',
    duration: '60分钟',
    views: 3210000,
    rating: 9.8,
    date: '2026-03-12',
    tags: ['文化', '历史', '国宝'],
  },
  {
    id: 'v12',
    title: '全职高手：荣耀归来',
    description: '电竞大神叶修重返荣耀职业联盟，用实力书写新的传奇篇章。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20esports%20scene%20with%20gaming%20characters%20in%20virtual%20arena%2C%20dynamic%20action%20pose%2C%20neon%20lights%2C%20cyberpunk%20elements%2C%20anime%20art%20style&width=800&height=450&seq=douhua-v12&orientation=landscape',
    duration: '22分钟/集',
    views: 9870000,
    rating: 9.4,
    date: '2026-08-05',
    tags: ['国漫', '电竞', '热血'],
  },
];